module.exports = __webpack_public_path__ + "static/tableyeti-logo-6e79b92fb543b70c40e6fc230a406ac0.png";